import { Box, Button, styled, Typography } from '@mui/material';
import { FC, useContext, } from 'react';
import AuthContext from '../contexts/auth/AuthContext';
import FilterButton from '../components/map/FilterButton';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import PhotosCard from '../components/datamanagement/PhotosCard';
import { SiteEventType } from '../api/dtos/dtos';
import MapContext from '../contexts/data/MapContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-duotone-svg-icons';

const ContentWrapper = styled(Box)(({ theme }) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.background.default,
}));

const PhotoGalleryContent: FC = () => {
    //
    // -- Contexts --
    const { filter } = useContext(MapContext);

    //
    // -- Params --
    const { species: speciesName } = useParams();

    // 
    // -- Hooks --
    const navigate = useNavigate();

    return (
        <Box>
            <ContentWrapper>
                {/* Header */}
                <Typography fontSize={32} color={"#FFFFFF"} sx={{paddingTop: "15px"}}>Photo Gallery</Typography>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'start',
                        color: 'white'
                    }}
                >
                    <Button
                        variant="text"
                        sx={{
                            color: 'white',
                            fontSize: '0.65rem',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.15)'
                            }
                        }}
                        startIcon={
                            <FontAwesomeIcon
                                icon={faArrowLeft} 
                                style={{ 
                                    color: 'white',
                                    fontSize: '0.65rem',
                                    paddingRight: '3px' 
                                }}
                            />
                        }
                        onClick={() => navigate("/" + speciesName + "/datamanagement")}
                    >
                        Back to Data Management
                    </Button>
                </Box>

                {/* Map Filter */}
                <Box style={{position: 'fixed', right: "0", padding: '16px', zIndex: 1}}>
                    <FilterButton 
                        loading={false}
                        disabled={false}
                    />
                </Box>
                
                {filter.recordType.sighting && (
                    <PhotosCard 
                        title={"Sighting"} 
                        siteeventtype={SiteEventType.Sighting}
                    />
                )}
                {filter.recordType.damage && (
                    <PhotosCard 
                        title={"Damage"} 
                        siteeventtype={SiteEventType.Damage}
                    />
                )}
                {filter.recordType.control && (
                    <PhotosCard 
                        title={"Control"} 
                        siteeventtype={SiteEventType.Control}
                    />
                )}
                {filter.recordType.disease && (
                    <PhotosCard 
                        title={"Disease"} 
                        siteeventtype={SiteEventType.Disease}
                    />
                )}

                <Box sx={{padding: "10px"}} />


            </ContentWrapper>
        </Box>
    )
}

const PhotoGalleryPage: FC = () => {
    const { user } = useContext(AuthContext);
    const { species: speciesName } = useParams();

    if (!user) {
        return <Navigate to={"/" + speciesName + "/map"} replace />
    }
    return (<PhotoGalleryContent />)
}

export default PhotoGalleryPage
